import { createAction } from 'typesafe-actions';
import { GenericAction, HttpErrorResponse } from '../../../../../types';
import { Alert } from '../../../types/alerts';

export const createAlert = createAction('ALERT_CREATE', (action) => (alert: Alert) => action(alert));
export const createSuccessAlert = createAction('ALERT_CREATE_SUCCESS', (action) => () => action());
export const removeAlert = createAction('ALERT_REMOVE', (action) => (id: string) => action(id));
export const setAlert = createAction('ALERT_SET', (action) => (act: GenericAction | HttpErrorResponse) => action(act));
